<<!--  -->
<template>
  <div>
    <div class="tips-box" v-if='tips==2'>
      <el-tooltip class="item" effect="dark" content="有新的交易完成，请及时处理！" placement="top-start">
        <i class="tips el-icon-warning" v-if="name=='transaction'"></i>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "tips",
  data() {
    return {
        tips:1,
        api:{
          orderStatus:'home/Merchant/orderStatus'
        }
    };
  },
  computed:{
    listentips(){
        return this.$store.state.transaction.tips
    }
  },
  watch:{
    listentips:function(old,newd){
      console.log(old)
        if(old==3){
            this.tips=1
        }
    },
    immediate:true,
    // deep:true
  },
  props: ["name"],
  components: {},
  created() {
    this.orderStatus()
    //   console.log(this.$store.state.transaction.tips)
    // console.log(this.name);
  },
  mounted() {},
  methods: {
    orderStatus(){
      let _this=this;
      let data={};
      this.$http({
        method:'GET',
        url:_this.api.orderStatus,
        params:data
      }).then(res=>{
        if(res.code==1){
            if(res.data.count>0){
              _this.tips=2
            }
        }else{
          console.log(res.msg)
        }
      })
    }
  }
};
</script>
<style  scoped>
.tips-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
}
.tips {
  position:absolute;
  color: #fff;
  font-size: 20px;
  color:#6435E8;
  border-radius: 50%;
  right:-13px;
  top:5px;
  /* right:-13px;
  top:4px; */
}
</style>